// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  MDBBtn, MDBCol, MDBContainer, MDBInput, MDBModal, MDBModalBody, MDBRow,
} from 'mdbreact';
import { toggleModal } from '../../storage/actions/modalsActions';
import { acceptPolicingAgreement } from '../../storage/actions/profile';

const AcceptAgreements = (
  {
    modalState,
    toggleModal,
    acceptPolicingAgreement,
    profile,
  },
) => {
  const [isAccpeted, setIsAccepted] = useState(false);
  const closeModal = () => toggleModal(!modalState.isOpen, 'acceptAgreements');
  const submitApprove = () => {
    acceptPolicingAgreement(profile.userId);
    closeModal();
  };
  return (<>
    <div className={`modal_block dashboard-modal dashboard-modal--centered modal_import ${modalState.isOpen ? 'showed' : ''}`}>
      <div className="modal_container " style={{minHeight: 'fit-content'}}>
        <div className="modal_head">
          <div className="modal_title">Accept Policy and Privacy Agreements</div>
          <button
            type="button"
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          />
        </div>
        <div className="modal_body">
          <div className="info_block">
            <div className="block_sub">
          <label className="check_btn">
            <input
            type="checkbox"
            className="regcheck "
            id="checkbox"
       
            checked={isAccpeted}
            onChange={() => {
              setIsAccepted(prev => !prev);
            }}
          />
          </label>
          {' '}
          I have read and agreed to the updated
              {' '}
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href="https://wurqly.com/Wurqly_terms_conditions.pdf"
                target="_blank"
                style={{
                  textDecorationLine: 'underline',
                  color: '#e87b68',
                }}
              >
                Term of Service
              </a>
              {' '}
              and
              {' '}
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href="https://wurqly.com/Wurqly_privicy_policy.pdf"
                target="_blank"
                style={{
                  textDecorationLine: 'underline',
                  color: '#e87b68',
                }}
              >
                Customer Privacy Policy
              </a>
            </div>
          </div>

        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="standard_btn dark_btn"
            aria-label="agree"
            onClick={submitApprove}
            disabled={!isAccpeted}
          >
            Agree
          </button>
        </div>
      </div>
    </div>
  
  </>
  );
};

const mapDispatchToProps = {
  toggleModal,
  acceptPolicingAgreement,
};

const mapStateToProps = state => ({
  modalState: state.modalState.acceptAgreements,
  profile: state.profile,
});

export default connect(mapStateToProps, mapDispatchToProps)(AcceptAgreements);
